// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable max-lines */
import React from 'react';
import PropTypes from 'prop-types';
import ProductImagesWrapper from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductImagesWrapper/views/ProductImagesWrapper.view';
import {
  getMapSliceForColorProductId,
  getImagesToDisplay,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import getPdpBrandLabel from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductBasicInfo/helpers/ProductBasicInfoHelper';
import ProductRating from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductRating/ProductRating';
import {
  isCanada,
  parseBoolean,
  getIconPath,
  changeOnlyFirstLetterToCapital,
} from '@tcp/core/src/utils/utils';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import Promotions from '@tcp/core/src/components/common/organisms/Promotions';
import { isClient, getViewportInfo, isUsOnly, getBrand, isPJP } from '@tcp/core/src/utils';
import LoyaltyBanner from '@tcp/core/src/components/features/CnC/LoyaltyBanner/index.js';
import RecommendationSkeleton from '@tcp/core/src/components/common/molecules/Recommendations/views/RecommendationSkeleton.view';
import MiniBagSelect from '@tcp/web/src/components/features/CnC/MiniBag/molecules/MiniBagSelectBox/MiniBagSelectBox';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Image from '@tcp/core/src/components/common/atoms/Image';
import FixedBreadCrumbs from '@tcp/core/src/components/features/browse/ProductListing/molecules/FixedBreadCrumbs/views/FixedBreadCrumbs.view';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import { PDP_SUB_LABELS, pdpSubLabels } from '@tcp/core/src/utils/labels/browse/PDP.labels';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { toSentenceCase } from '@tcp/core/src/components/common/organisms/ProductPickup/utils/ProductPickup.utils.js';
import ProductPrice from '../../ProductPrice/ProductPrice';
import PlccWrapperStatic from '../../PlccWrapperStatic/views/PlccWrapperStatic.view';
import ZoneOneBadges from '../../../../PlpTile/views/ZoneOneBadges.view';
import withStyles from '../../../../../../common/hoc/withStyles';
import LoaderSkelton from '../../../../../../common/molecules/LoaderSkelton';
import styles, {
  ColorSwatchSkeleton,
  PDPTabsSkeleton,
  PDPRecommendation,
  PDPATBSkeleton,
  StyledModuleLoader,
  SizeSkeleton,
} from '../styles/ProductDetailSkeleton.style';
import { BadgeItem } from '../../../../ProductListing/molecules/ProductList/views/ProductItemComponents';
import { ZoneOneBadgesWrapper } from '../../../../PlpTile/views/styles/ZoneOneBadges.style';

const ProductDetailsSkeletonStructure = (className) => {
  const thumbnailList = [];
  for (let itr = 0; itr < 5; itr += 1) {
    thumbnailList.push(
      <div className="thumbnail-list">
        <LoaderSkelton />
      </div>
    );
  }
  return (
    <div className={className}>
      <Row>
        <Col className="product-breadcrumb-wrapper" colSize={{ small: 6, medium: 8, large: 12 }} />
      </Row>
      <Row fullBleed className="product-detail-skeleton-wrapper">
        <div className="thumbnail-list-wrapper">{thumbnailList}</div>
        <div className="product-skeleton-img" />
        <div className="product-overview-wrapper">
          {[
            'product-title',
            'product-price',
            'product-color',
            'product-size',
            'product-add-to-bag',
          ].map((classValue) => (
            <div className={classValue} key={classValue}>
              <LoaderSkelton />
            </div>
          ))}
        </div>
      </Row>
    </div>
  );
};

const getSingleImageObj = (uniqueId) => {
  const imagePath = `${uniqueId?.split('_')[0]}/${uniqueId}`;
  return [
    {
      isShortImage: false,
      isOnModalImage: false,
      iconSizeImageUrl: imagePath,
      listingSizeImageUrl: imagePath,
      regularSizeImageUrl: imagePath,
      bigSizeImageUrl: imagePath,
      superSizeImageUrl: imagePath,
    },
  ];
};

// eslint-disable-next-line complexity
const ProductDetailSkeleton = ({
  className,
  retrievedProductInfo,
  ratingsProductId,
  isKeepAliveEnabled,
  currencyAttributes,
  currency,
  imgConfigVal,
  isDynamicBadgeEnabled,
  fromPLPPage,
  isPDPSmoothScrollEnabled,
  isHiddenPDPAltImageEnabled,
  primaryBrand,
  alternateBrand,
  isNewPJPPDPRedesignEnabled,
  isHideOriginalPriceAndMarchantTagEnabled,
  isPlccPriceOnPDP,
  breadCrumbs,
  isSearchPage,
  IsImageIndicatorUpdateEnabled,
  showDynamicContentLoader,
  aspectRatioObjNew,
  isPDPRedesignEnabled,
  isDeptClicked,
  plccOfferPercentage,
  isUpdatedPromotionsDisplayEnabled,
  isStoreSpecialsPriceOn,
  storeSpecialDiscount,
  fromBagPage,
  isClickableBrandBadgesEnabled,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const backToResults = getLabelFromCopyOrFromTranslation(
    `${PDP_SUB_LABELS}.lbl_back_to_results`,
    pdpSubLabels
  );
  if (!retrievedProductInfo || isDeptClicked) {
    return ProductDetailsSkeletonStructure(className);
  }
  const {
    name,
    colorFitsSizesMap,
    uniqueId,
    imagesByColor,
    tcpStyleQty,
    tcpStyleType,
    plpTopBadge,
    dataSource,
    auxdescription,
    ratings,
    reviewsCount,
    listPrice,
    offerPrice,
    priceRange,
    isGiftCard,
    merchantTag,
    hardMarkDown,
    isBundleProduct,
    promotionsData,
    TCPSwatches,
    promotionalMessage,
    promotionalPLCCMessage,
    TCPPromotionPrice,
    TCPPromotionID,
    imageConfigWithoutDPR,
    variantTotal,
    zoneOneBadgesArray,
    isStoreSpecialEligible,
    storeSpecials,
    dynamicBadgeOverlayQty,
    TCPColor,
    isLicensed,
    isBigIdeaLicensedProductBrand,
  } = retrievedProductInfo;
  const showColorChips =
    (TCPSwatches && TCPSwatches.split('|')?.length > 1) || colorFitsSizesMap?.length > 1;
  const colorChips = (TCPSwatches && TCPSwatches?.split('|')) || colorFitsSizesMap;
  const isMobile = isClient() ? getViewportInfo().isMobile : null;
  const colorName =
    changeOnlyFirstLetterToCapital(TCPColor) ||
    (auxdescription && auxdescription.charAt(0) + auxdescription.slice(1).toLowerCase());
  const currentColorEntry = getMapSliceForColorProductId(colorFitsSizesMap, uniqueId) || {};
  const keepAlive =
    isKeepAliveEnabled && currentColorEntry.miscInfo && currentColorEntry.miscInfo.keepAlive;
  const currentProduct = { colorFitsSizesMap };
  let imagesToDisplay = getImagesToDisplay({
    imagesByColor,
    curentColorEntry: currentColorEntry,
    isAbTestActive: false,
    isFullSet: true,
    excludeShortImage: false,
  });
  if ((Array.isArray(imagesToDisplay) && imagesToDisplay.length === 0) || !imagesToDisplay) {
    imagesToDisplay = getSingleImageObj(uniqueId);
  }
  const isHideOriginalPrice = hideProductOriginalPrice(
    hardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled
  );
  const { miscInfo: { badge1 = {} } = {} } = currentColorEntry;

  const topBadge = plpTopBadge || badge1.defaultBadge;
  const prodBrand = '';
  const brandLabel = getPdpBrandLabel({ primaryBrand, alternateBrand, prodBrand });
  const prices = {
    listPrice,
    offerPrice,
    badge2: merchantTag,
  };

  const getRecommendationSkeleton = () => {
    return (
      <Row
        className="pdp-recommendations-wrapper"
        fullBleed={{ small: true, medium: true, large: false }}
      >
        <Col colSize={{ small: 6, medium: 8, large: 12 }}>
          <div className="product-detail-section product-description-list">
            <div className="hide-skeleton-largeDesktop">
              {<RecommendationSkeleton variations="moduleO" isNewPDPEnabled isPDP />}
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const getColorChipsSkeleton = () => {
    return colorChips.map((item) => {
      return (
        <div key={item} className="image-chips-selector-item">
          <span>
            <LoaderSkelton />
          </span>
        </div>
      );
    });
  };

  const quantityArray = new Array(15).fill(1);
  const quantityList = quantityArray.map((val, index) => ({
    displayName: index + 1,
    id: index + 1,
  }));

  const getBackButton = (buttonText, backAction) => {
    return (
      <div className="go-back-container">
        <button type="button" onClick={backAction} className="button-go-back">
          <Image src={getIconPath('medium-left-arrow')} alt="" />
          <BodyCopy className="back-button" fontFamily="secondary" fontSize="fs16">
            {buttonText}
          </BodyCopy>
        </button>
      </div>
    );
  };

  const triggerBack = (e) => {
    e.preventDefault();
    if (window.history.length > 2) window.history.back();
  };

  const getBreadCrumb = () => {
    if (parseBoolean(isSearchPage)) {
      return getBackButton(backToResults, triggerBack);
    }
    if (breadCrumbs) {
      return <FixedBreadCrumbs crumbs={breadCrumbs} separationChar=">" isPDPPage />;
    }
    return null;
  };

  const getTitle = () => {
    const commonProps = {
      className: `product-title new-pdp-colour${isPDPRedesignEnabled ? ' title-redesign' : ''}`,
      fontSize: '22px',
      component: 'h1',
      fontFamily: 'secondary',
      fontWeight: 'extrabold',
      itemprop: 'name',
      tabIndex: 0,
    };

    const titleContent = (
      <BodyCopy {...commonProps}>{colorName ? `${name} - ${colorName}` : name}</BodyCopy>
    );

    const ratingContent = (
      <div
        className={`rating-section-bottom${
          isPDPRedesignEnabled ? ' rating-section-bottom-redesigned' : ''
        }`}
      >
        <ProductRating
          ratings={ratings || 0}
          reviews={reviewsCount || 0}
          isNewPDPEnabled={true}
          pageName="PDP"
          ratingsProductId={uniqueId}
          primaryBrand={primaryBrand || alternateBrand}
          productName={name}
          colorDisplayId={uniqueId}
          isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
          isPDPRedesignEnabled={isPDPRedesignEnabled}
        />
      </div>
    );

    return (
      <div className="information-container">
        <div className={`title-wrapper${isPDPRedesignEnabled ? '-new' : ''}`}>
          {titleContent}
          {ratingContent}
        </div>
      </div>
    );
  };

  const productInfo = {
    primaryBrand,
    alternateBrand,
    ratings,
    reviewsCount,
    productId: uniqueId,
  };

  const renderBadge = () => {
    if (zoneOneBadgesArray?.length > 0) {
      return (
        <ZoneOneBadgesWrapper>
          {zoneOneBadgesArray.map((badge) => {
            return (
              <ZoneOneBadges key={badge.priority.toString()} type={badge.type} text={badge.label} />
            );
          })}
        </ZoneOneBadgesWrapper>
      );
    }
    return null;
  };
  return (
    <div className={className}>
      <Row>
        <Col
          className={`${isSearchPage ? 'search-breadcrumb-wrapper' : 'product-breadcrumb-wrapper'}`}
          colSize={{ small: 6, medium: 8, large: 12 }}
        >
          {getBreadCrumb()}
        </Col>
      </Row>
      {isPDPRedesignEnabled && (
        <Row className="pdp-redesign-skeleton product-summary-mobile-view-new-design">
          {renderBadge()}
          {isClickableBrandBadgesEnabled && isLicensed && isBigIdeaLicensedProductBrand ? (
            <Anchor
              to={`/search?searchQuery=*?TCPBigIdeaLicensedProductBrand_uFilter=${isBigIdeaLicensedProductBrand}`}
              asPath={`/search/*?TCPBigIdeaLicensedProductBrand_uFilter=${isBigIdeaLicensedProductBrand}`}
              className="product-brand-licensed"
            >
              {isBigIdeaLicensedProductBrand}
            </Anchor>
          ) : (
            <BodyCopy
              fontSize="fs18"
              fontWeight="bold"
              fontFamily="secondary"
              className="product-brand-redesign"
            >
              {brandLabel}
            </BodyCopy>
          )}

          {getTitle()}
        </Row>
      )}
      <Row className="product-detail-skeleton-wrapper product-content-wrapper">
        <Col className="product-image-wrapper" colSize={{ small: 6, medium: 4, large: 7 }}>
          <ProductImagesWrapper
            productName={name}
            isThumbnailListVisible
            images={imagesToDisplay}
            isZoomEnabled
            currentProduct={currentProduct}
            currentColorEntry={currentColorEntry}
            initialValues={null}
            keepAlive={keepAlive}
            ratingsProductId={ratingsProductId}
            imgConfigVal={imgConfigVal}
            TCPStyleQTY={tcpStyleQty}
            TCPStyleType={tcpStyleType}
            isDynamicBadgeEnabled={isDynamicBadgeEnabled}
            fromPLPPage={fromPLPPage || dataSource === 'recommendation'}
            isPDPSmoothScrollEnabled={isPDPSmoothScrollEnabled}
            primaryBrand={primaryBrand}
            alternateBrand={alternateBrand}
            isNewPDPEnabled
            isHiddenPDPAltImageEnabled={isHiddenPDPAltImageEnabled}
            pageName="PDP"
            isPDP
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
            IsImageIndicatorUpdateEnabled={IsImageIndicatorUpdateEnabled}
            imageConfigWithoutDPR={imageConfigWithoutDPR}
            fromBagPage={fromBagPage}
            dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
          />
          <ProductImagesWrapper
            className="product-detail-main-skeleton-image"
            productName={name}
            isThumbnailListVisible
            images={imagesToDisplay}
            isZoomEnabled
            currentProduct={currentProduct}
            currentColorEntry={currentColorEntry}
            initialValues={null}
            keepAlive={keepAlive}
            ratingsProductId={ratingsProductId}
            imgConfigVal={imgConfigVal}
            TCPStyleQTY={tcpStyleQty}
            TCPStyleType={tcpStyleType}
            isDynamicBadgeEnabled={isDynamicBadgeEnabled}
            fromPLPPage={false}
            isPDPSmoothScrollEnabled={isPDPSmoothScrollEnabled}
            primaryBrand={primaryBrand}
            alternateBrand={alternateBrand}
            isNewPDPEnabled
            isHiddenPDPAltImageEnabled={isHiddenPDPAltImageEnabled}
            pageName="PDP"
            isPDP
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
            IsImageIndicatorUpdateEnabled={IsImageIndicatorUpdateEnabled}
            imageConfigWithoutDPR={imageConfigWithoutDPR}
            fromBagPage={fromBagPage}
            dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
          />
        </Col>
        <Col colSize={{ small: 6, medium: 4, large: 5 }} className="product-overview-wrapper">
          <div className="product-details-header-container">
            <div className="sub-header-wrapper">
              {showColorChips && isMobile && !isPDPRedesignEnabled && (
                <ColorSwatchSkeleton>
                  <div className="image-chips-selector-items-list">{getColorChipsSkeleton()}</div>
                </ColorSwatchSkeleton>
              )}
              {!isPDPRedesignEnabled && (
                <BadgeItem
                  customFontWeight="regular"
                  customFontSize={['fs10', 'fs10', 'fs10']}
                  className="inline-badge-item"
                  text={topBadge}
                />
              )}
              {!isPDPRedesignEnabled && (
                <BodyCopy
                  fontSize="fs18"
                  fontWeight="bold"
                  fontFamily="secondary"
                  className="product-brand"
                >
                  {brandLabel}
                </BodyCopy>
              )}
              {!isPDPRedesignEnabled && getTitle()}
              {isPDPRedesignEnabled && (
                <Row className="pdp-redesign-skeleton product-summary-non-mobile-view-new-design">
                  {renderBadge()}
                  {isClickableBrandBadgesEnabled && isLicensed && isBigIdeaLicensedProductBrand ? (
                    <Anchor
                      to={`/search?searchQuery=*?TCPBigIdeaLicensedProductBrand_uFilter=${isBigIdeaLicensedProductBrand}`}
                      asPath={`/search/*?TCPBigIdeaLicensedProductBrand_uFilter=${isBigIdeaLicensedProductBrand}`}
                      className="product-brand-licensed"
                    >
                      {toSentenceCase(isBigIdeaLicensedProductBrand)}
                    </Anchor>
                  ) : (
                    <BodyCopy
                      fontSize="fs18"
                      fontWeight="bold"
                      fontFamily="secondary"
                      className="product-brand-redesign"
                    >
                      {brandLabel}
                    </BodyCopy>
                  )}

                  {getTitle()}
                </Row>
              )}
              <ProductPrice
                listPrice={listPrice}
                offerPrice={offerPrice}
                hideItemProp
                currencySymbol={currency}
                currencyAttributes={currencyAttributes}
                isGiftCard={isGiftCard}
                priceRange={priceRange}
                badge2={merchantTag}
                isAfterPayDisplay={true}
                isNewPJPPDPRedesignEnabled={true}
                isNewPDPEnabled
                isHideOriginalPrice={isHideOriginalPrice}
                promotionalMessage={promotionalMessage}
                promotionalPLCCMessage={promotionalPLCCMessage}
                productInfo={isMobile ? productInfo : {}}
                colorProductId={''}
                isPDPRedesignEnabled={isPDPRedesignEnabled}
                isPDPRedesignPrice={isPDPRedesignEnabled}
                TCPPromotionID={TCPPromotionID}
                TCPPromotionPrice={TCPPromotionPrice}
                isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
                storeSpecials={isStoreSpecialEligible || parseBoolean(storeSpecials)}
                isStoreSpecialsPriceOn={isStoreSpecialsPriceOn}
                storeSpecialDiscount={storeSpecialDiscount}
                hideStoreSpecial={true}
              />
              {!isMobile && TCPPromotionID && (
                <Promotions
                  underLine
                  showArrow
                  showIcon={false}
                  showHeading
                  TCPPromotionPrice={TCPPromotionPrice}
                  TCPPromotionID={TCPPromotionID}
                  isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
                  className="isPDP pdp-redesign-promo-wrapper"
                  isStyleWith={false}
                  pageName="PDP"
                  brand={primaryBrand || alternateBrand}
                  isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                  promotionsData={promotionsData || {}}
                  isPDPRedesignPromo={true}
                />
              )}
              {!isCanada() && !isBundleProduct && !isPDPRedesignEnabled && (
                <PlccWrapperStatic
                  openModal={false}
                  prices={prices}
                  currencyAttributes={currencyAttributes}
                  isPlccPriceOnPDP={isPlccPriceOnPDP}
                  plccOfferPercentage={plccOfferPercentage}
                />
              )}

              {showColorChips && (!isMobile || isPDPRedesignEnabled) && (
                <ColorSwatchSkeleton>
                  <div className="image-chips-selector-title-box">
                    <BodyCopy className={`image-chips-selector-title`}>
                      <span>Color:</span>
                    </BodyCopy>
                    <LoaderSkelton width="100px" />
                  </div>
                  <div className="image-chips-selector-items-list">{getColorChipsSkeleton()}</div>
                </ColorSwatchSkeleton>
              )}
              {variantTotal ? (
                <div className="size-skeleton">
                  <SizeSkeleton>
                    <div className="size-selector-title-box">
                      <BodyCopy className={`size-selector-title`}>
                        <span>Size:</span>
                      </BodyCopy>
                      <LoaderSkelton width="100px" />
                    </div>
                  </SizeSkeleton>
                  {Array(variantTotal)
                    .fill(null)
                    .map((key) => {
                      return <LoaderSkelton key={key} className="pdp-size-skeleton" />;
                    })}
                </div>
              ) : (
                <SizeSkeleton>
                  <div className="size-selector-title-box">
                    <BodyCopy className={`size-selector-title`}>
                      <span>Size:</span>
                    </BodyCopy>
                    <LoaderSkelton width="100px" />
                  </div>
                </SizeSkeleton>
              )}
            </div>
          </div>
          <PDPATBSkeleton>
            <div>
              <LoaderSkelton className="pdp-delivery-skeleton" />
            </div>
            <div className="store-option">
              <LoaderSkelton className="product-store-option" />
            </div>
            <div className="atb-or-pickup">
              <div className="new-pdp-qty-selector">
                <MiniBagSelect
                  input={{ name: 'Quantity', onChange: () => {}, value: 1 }}
                  id={'quantity-new-qv'}
                  options={quantityList}
                  keepAlive={false}
                  disabled={true}
                  newQVDesign={true}
                  isNewPDPEnabled={true}
                />
              </div>

              <Button
                type="submit"
                uniqueKey={uniqueId}
                className={`atb-button add-to-bag-button`}
                buttonVariation="variable-width"
                id={`brand-${getBrand()} -${1}`}
                disabled={true}
                fill={isPJP() ? 'PJP_PRIMARY' : ''}
              >
                Add TO BAG
              </Button>
            </div>
          </PDPATBSkeleton>
          <div className={`${isUsOnly() ? 'border-background-new-design' : ''}`}>
            <div className={`${isUsOnly() ? 'loyalty-banner-wrapper-new-design' : ''}`}>
              <LoyaltyBanner
                pageCategory="isProductDetailView"
                ratingsProductId={ratingsProductId}
                isCompleteTheLookTestEnabled={false}
              />
              {!isCanada() && !isBundleProduct && (
                <PlccWrapperStatic
                  openModal={false}
                  isPDPRedesignEnabled={true}
                  prices={prices}
                  currencyAttributes={currencyAttributes}
                  isPlccPriceOnPDP={isPlccPriceOnPDP}
                  plccOfferPercentage={plccOfferPercentage}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
      {showDynamicContentLoader && (
        <StyledModuleLoader aspectRatioObject={aspectRatioObjNew}>
          <LoaderSkelton className={'module-loader'} />
        </StyledModuleLoader>
      )}
      <PDPTabsSkeleton>
        <LoaderSkelton />
      </PDPTabsSkeleton>
      <PDPRecommendation>
        <React.Fragment>
          {getRecommendationSkeleton()}
          {getRecommendationSkeleton()}
        </React.Fragment>
      </PDPRecommendation>
    </div>
  );
};

ProductDetailSkeleton.propTypes = {
  className: PropTypes.string.isRequired,
  retrievedProductInfo: PropTypes.shape({}),
  breadCrumbs: PropTypes.shape([]),
  ratingsProductId: PropTypes.string.isRequired,
  isKeepAliveEnabled: PropTypes.shape({}),
  currencyAttributes: PropTypes.shape({}).isRequired,
  currency: PropTypes.string.isRequired,
  imgConfigVal: PropTypes.shape([]),
  isShowPriceRangeKillSwitch: PropTypes.bool.isRequired,
  showPriceRangeForABTest: PropTypes.bool.isRequired,
  isDynamicBadgeEnabled: PropTypes.shape({}),
  // eslint-disable-next-line max-lines
  fromPLPPage: PropTypes.bool,
  isPDPSmoothScrollEnabled: PropTypes.bool,
  isHiddenPDPAltImageEnabled: PropTypes.bool,
  isShowBrandNameEnabled: PropTypes.bool,
  primaryBrand: PropTypes.string,
  alternateBrand: PropTypes.string,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  isHideOriginalPriceAndMarchantTagEnabled: PropTypes.bool,
  isPlccPriceOnPDP: PropTypes.bool,
  IsImageIndicatorUpdateEnabled: PropTypes.bool,
  variantTotal: PropTypes.number,
  zoneOneBadgesArray: PropTypes.shape([]),
  fromBagPage: PropTypes.bool,
};

ProductDetailSkeleton.defaultProps = {
  retrievedProductInfo: {},
  breadCrumbs: [],
  isKeepAliveEnabled: false,
  imgConfigVal: [],
  isDynamicBadgeEnabled: false,
  fromPLPPage: false,
  isPDPSmoothScrollEnabled: false,
  isHiddenPDPAltImageEnabled: false,
  isShowBrandNameEnabled: false,
  primaryBrand: '',
  alternateBrand: '',
  isNewPJPPDPRedesignEnabled: false,
  isHideOriginalPriceAndMarchantTagEnabled: false,
  isPlccPriceOnPDP: false,
  IsImageIndicatorUpdateEnabled: false,
  variantTotal: undefined,
  zoneOneBadgesArray: [],
  fromBagPage: false,
};

export default withStyles(ProductDetailSkeleton, styles);
export { ProductDetailSkeleton as ProductDetailSkeletonVanilla };
